module.exports = {
  NONE: 'none',
  GEOLOCATION: 'geolocation',
  FULL: 'full',
};
